// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionButton.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Action Button component
 */
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var FloatAffixed = require('share/components/controls/Izenda.FloatAffixed');
  var UiState = require('logic/Izenda.UiState');
  var localizer = require('share/localization/Izenda.Localizer');
  const { filter, isObject } = require('lodash/fp');
  var ActionButton = React.createClass({
    getInitialState: function() {
      return {
        isOpen: false
      };
    },

    hideMenu: function(event) {
      this.setState({ isOpen: false });
    },

    showMenu: function(event) {
      this.setState({
        isOpen: !this.state.isOpen
      });
    },

    renderActionButtons: function() {
      var buttons = filter(function(item) {
        return isObject(item) && !item.props.keepDisplay;
      }, this.props.children);
      return buttons.map(
        function(item, index) {
          return (
            <div key={index} onClick={this.hideMenu}>
              {' '}
              {item}{' '}
            </div>
          );
        }.bind(this)
      );
    },

    renderStaticButtons: function() {
      return filter(function(item) {
        return isObject(item) && item.props.keepDisplay;
      }, this.props.children);
    },

    render: function() {
      if (!UiState.isMobile) {
        return <div className='u_inlineBlock izenda-ActionButton'>{this.props.children}</div>;
      }

      return (
        <div className='u_inlineBlock izenda-ActionButton'>
          <button ref='btnAction' onMouseDown={this.showMenu} className='btn btn-primary'>
            {localizer.getText('COMMON_LABEL_ACTION')} &nbsp;
            <span className='caret' />
          </button>
          {this.renderStaticButtons()}
          {this.state.isOpen && (
            <FloatAffixed
              className='izenda-ActionButton-menu'
              edges='under,over'
              renderInContainer={false}
              autoWidth
              anchor={this.refs.btnAction}
              onClickOutside={this.hideMenu}
            >
              <div>{this.renderActionButtons()}</div>
            </FloatAffixed>
          )}
        </div>
      );
    }
  });

  module.exports = observer(ActionButton);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ActionButton.jsx